<div class="d-flex align-items-center gap-10 w-100">
  @if (cellData().online) {
    <div class="status status--success">
      <span>Online</span>
    </div>
  } @else if (errorDetails()?.isConnecting) {
    <div class="status status--warning">
      <span>Connecting...</span>
    </div>
  } @else {
    <div class="error-status-wrapper">
      @if (cellData().enabled === false) {
        <div class="status status--error">
          <span>Disabled</span>
        </div>
      } @else {
        <div class="status status--error">
          <span>{{ errorDetails()?.shortText }}</span>
          <span class="icon-external"></span>
        </div>

        @if (isReconnecting()) {
          <span class="retry-count">{{ errorDetails()?.failedTimes || '0' }} attempts - retrying </span>
        } @else {
          <span class="retry-count">Retries: {{ errorDetails()?.failedTimes || '0' }}</span>
        }
      }
    </div>
  }
</div>
